import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../public/images/HeadBar.svg'


const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "content_front" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "code_employes",
  src: _imports_0,
  alt: "HeadBar"
}, null, -1)
const _hoisted_4 = { class: "employes__name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "let_employes" }, "let", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "variable_employes" }, " name", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" = ")
const _hoisted_8 = { class: "employes__main" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("; ")
const _hoisted_10 = { class: "employes__position" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "let_employes" }, "let", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "variable_employes" }, " position", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" = ")
const _hoisted_14 = { class: "employes__main" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("; ")
const _hoisted_16 = { class: "employes__experience" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "let_employes" }, " let ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "variable_employes" }, "workExperience", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" = ")
const _hoisted_20 = { class: "employes__main" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("; ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: $props.employes.avatarLink,
      alt: $props.employes.id
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, "'" + _toDisplayString($props.employes.name) + "'", 1),
        _hoisted_9
      ]),
      _createElementVNode("p", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("span", _hoisted_14, "'" + _toDisplayString($props.employes.position) + "'", 1),
        _hoisted_15
      ]),
      _createElementVNode("p", _hoisted_16, [
        _hoisted_17,
        _hoisted_18,
        _hoisted_19,
        _createElementVNode("span", _hoisted_20, "'" + _toDisplayString($props.employes.workExperience) + "'", 1),
        _hoisted_21
      ])
    ])
  ], 64))
}